/**
 * Application route path constants.
 *
 * Centralises all route paths so that navigation links and route definitions
 * always stay in sync. Import from here instead of using raw strings.
 */

export const ROUTES = {
  // Public
  HOME: "/",
  LANDING: "/",
  LOGIN: "/login",
  LOGIN_OTP: "/login/otp",
  /** WULOOJ platform operator login (branded) */
  SA_LOGIN: "/superadmin/login",
  LOGOUT: "/logout",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password/:uuid",
  VERIFY_PASSWORD: "/verify-password",
  REGISTER: "/register",
  REGISTER_PLANS: "/register/plans",
  REGISTER_PAYMENT: "/register/payment",
  REGISTER_SUCCESS: "/register/success",
  PLAN_PAYMENT: "/pay/subscription",
  DELETE_ACCOUNT: "/delete-account",
  PUBLIC_RATING: "/rating/:branchId",
  PUBLIC_PRIVACY_POLICY: "/:identifier/privacy-policy",
  PUBLIC_TERMS_CONDITIONS: "/:identifier/terms-and-conditions",
  PUBLIC_RIDER_PRIVACY_POLICY: "/:identifier/rider/privacy-policy",
  PUBLIC_RIDER_TERMS_CONDITIONS: "/:identifier/rider/terms-and-conditions",

  // Auth (protected)
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  CHANGE_PASSWORD: "/change-password",
  MY_PREFERENCE: "/my-preference",
  EXPORT_REQUESTS: "/export-requests",

  // Users & Roles
  USERS: "/users",
  ADD_USER: "/add-user",
  VIEW_USER: "/view-user/:id",
  ROLES: "/roles",
  ADD_ROLE: "/add-role",
  VIEW_ROLE: "/role-details/:id",

  // Customers
  CUSTOMERS: "/customers",
  VIEW_CUSTOMER: "/customers/:id",
  EDIT_CUSTOMER: "/edit-customer/:id",

  // Locations
  LOCATIONS: "/locations",
  ADD_LOCATION: "/add-location",
  VIEW_LOCATION: "/view-location/:id",

  // Orders
  ORDERS: "/orders",
  B2C_ORDERS: "/orders",
  VIEW_ORDER: "/view-order/:id",

  // Menus
  CATEGORIES: "/categories",
  ITEMS: "/items",
  MODIFIER_GROUPS: "/modifier-groups",

  // Promotions & Coupons
  PROMOTIONS: "/discounts",
  COUPONS_GROUP: "/coupons-group",
  COUPONS: "/coupons",

  // Notifications
  APP_NOTIFICATIONS: "/app-notifications",
  PUSH_NOTIFICATIONS: "/push-notifications",

  // Reports
  REPORTS: "/reports",
  API_LOGS: "/api-logs",

  // Error pages
  NOT_FOUND: "/404",
  SERVER_ERROR: "/500",
  FORBIDDEN: "/forbidden",
  UNAUTHORIZED: "/unauthorized",
  SESSION_EXPIRED: "/session-expired",

  // Billing & Subscription
  BILLING_DASHBOARD: "/billing",
  BILLING_PLANS: "/billing/plans",
  BILLING_CHECKOUT: "/billing/checkout",
  BILLING_INVOICES: "/billing/invoices",
  BILLING_INVOICE_DETAILS: "/billing/invoices/details",

  // Superadmin — platform dashboard & Tenants
  SA_DASHBOARD: "/superadmin/dashboard",
  SA_TENANTS: "/superadmin/tenants",
  SA_ROLES: "/superadmin/roles",
  SA_ROLE_ADD: "/superadmin/roles/add",
  SA_ROLE_EDIT: "/superadmin/roles/edit",
  SA_ROLE_DETAILS: "/superadmin/roles/role-details",
  SA_USERS: "/superadmin/users",
  SA_USER_ADD: "/superadmin/users/add",
  SA_USER_EDIT: "/superadmin/users/edit",
  SA_USER_DETAILS: "/superadmin/users/user-details",
  SA_TENANT_ADD: "/superadmin/tenants/add",
  SA_TENANT_EDIT: "/superadmin/tenants/edit",
  SA_TENANT_DETAILS: "/superadmin/tenants/details",

  // Superadmin — Plans
  SA_PLANS: "/superadmin/plans",
  SA_PLAN_ADD: "/superadmin/plans/add",
  SA_PLAN_EDIT: "/superadmin/plans/edit",
  SA_PLAN_VIEW: "/superadmin/plans/view",

  // Superadmin — Billing oversight
  SA_SUBSCRIPTIONS: "/superadmin/billing/subscriptions",
  SA_INVOICES: "/superadmin/billing/invoices",
  SA_INTEGRATIONS: "/superadmin/integrations",

  SA_BRANDS: "/superadmin/brands",
  SA_BRAND_ADD: "/superadmin/brands/add",
  SA_BRAND_EDIT: "/superadmin/brands/edit",
  SA_BRAND_DETAILS: "/superadmin/brands/brand-details",

  // Superadmin — Countries (platform-level CRUD)
  SA_COUNTRIES: "/superadmin/countries",
  SA_COUNTRY_ADD: "/superadmin/countries/add",
  SA_COUNTRY_EDIT: "/superadmin/countries/edit",
  SA_COUNTRY_DETAILS: "/superadmin/countries/country-details",
}
